import { Routes } from '@angular/router';

export const rootRouterConfig: Routes = [
  {
    path: '',
    loadChildren: () => import('./shop/shop.module').then(m => m.ShopModule)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
